export const PAGE_TITLE = 'add-ons';
